// extracted by mini-css-extract-plugin
export default {"tooltip":"Yp-z","sharingV2":"Zp-z","sharingIconsV2":"_p-z","links":"aq-z","link":"bq-z","facebookV2":"cq-z","twitterV2":"dq-z","pinterestV2":"eq-z"};